import "./AppPaginator.scss";
import Paginate from "vuejs-paginate/src/components/Paginate";

export default {
  extends: Paginate,
  props: {
    containerClass: {
      type: String,
      default: "paginator"
    },
    prevText: {
      type: String,
      default: ""
    },
    nextText: {
      type: String,
      default: ""
    },
    pageLinkClass: {
      type: String,
      default: "paginator__btn btn"
    },
    hidePrevNext: {
      type: Boolean,
      default: true
    },
    noLiSurround: {
      type: Boolean,
      default: true
    }
  }
};
